import './App.css';
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './components/Home/Home';
import NotFound from './components/NotFound/NotFound';
import TeamDetail from './components/TeamDetail/TeamDetail';
import 'bootstrap/dist/css/bootstrap.min.css';
import Contact from './components/Contact/Contact';
function App() {
  return (
    <div >     
      <Router>
        <Switch >
          <Route exact path="/">
            <Home></Home>
          </Route>

          <Route path="/home">
            <Home></Home>
          </Route>

          <Route exact path="/leagues/:id">
            <TeamDetail></TeamDetail>
          </Route>
          <Route exact path="/leagues/:id">
            <Contact></Contact>
          </Route>

          {/* <Route path="/leagues/:id">
            <Contact></Contact>
          </Route> */}

          <Route path="*">
            <NotFound></NotFound>
          </Route>

        </Switch>
      </Router>
      
    
    </div>
  );
}

export default App;
